export default "__VITE_ASSET__ad2cbea3__"